module.exports = __webpack_public_path__ + "img/frontend_base_registro.27211014.jpg";